import { useEffect } from "react";

const DEFAULTS = {
  title: "Gulf Coast Home Co. — Built to feel lived in.",
  description:
    "Rugged Gulf Coast finds for backwater living, dock life, outdoor gear, and everyday carry.",
  image:
    "https://customer-assets.emergentagent.com/job_gulf-coast-home/artifacts/nbwe9z7d_IMG_8592.png",
};

function setMeta(selector, attr, value) {
  if (!value) return;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const [, key] = selector.match(/\[(.+?)=/) || [];
    if (key) {
      const propMatch = selector.match(/\[(name|property)="([^"]+)"\]/);
      if (propMatch) el.setAttribute(propMatch[1], propMatch[2]);
    }
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

/** Update title + Open Graph + Twitter + Pinterest-rich tags for the current page. */
export default function usePageMeta({ title, description, image, type = "website" } = {}) {
  useEffect(() => {
    const t = title ? `${title} — Gulf Coast Home Co.` : DEFAULTS.title;
    const d = description || DEFAULTS.description;
    const i = image || DEFAULTS.image;
    document.title = t;

    setMeta('meta[name="description"]', "content", d);
    setMeta('meta[property="og:title"]', "content", t);
    setMeta('meta[property="og:description"]', "content", d);
    setMeta('meta[property="og:image"]', "content", i);
    setMeta('meta[property="og:type"]', "content", type);
    setMeta('meta[property="og:url"]', "content", window.location.href);
    setMeta('meta[name="twitter:card"]', "content", "summary_large_image");
    setMeta('meta[name="twitter:title"]', "content", t);
    setMeta('meta[name="twitter:description"]', "content", d);
    setMeta('meta[name="twitter:image"]', "content", i);
    // Pinterest reads og: tags; ensure pinterest-rich-pin description present
    setMeta('meta[name="pinterest-rich-pin"]', "content", "true");
  }, [title, description, image, type]);
}

export function readingTime(content = "") {
  const words = content.trim().split(/\s+/).filter(Boolean).length;
  return Math.max(1, Math.round(words / 200));
}
